import { LanguageService } from '@hio/language';

import de from './i18n/de.json';
import en from './i18n/en.json';
import es from './i18n/es.json';
import fr from './i18n/fr.json';
import it from './i18n/it.json';
import nl from './i18n/nl.json';
import pl from './i18n/pl.json';

const NAMESPACE = 'shareBasic';

/** Registers share-basic strings once; safe to call from any component. */
export function ensureShareBasicI18n(lang: LanguageService): LanguageService {
  lang.register(NAMESPACE, { de, en, es, fr, it, nl, pl });
  return lang;
}
